import { useEffect, useState } from "react";
import styles from "../updates/Update.module.css";
import AIWorks_Guides from "../../assets/AIWORKS_Guidance.pdf";
import HeaderInfo from "../layout/HeaderInfo";

const GuideLines = () => {
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight
    });

    useEffect(() => {
        const handleResize = () => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight
            });
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <div style={{ display: "flex" }}>
            <div>
                <header className={styles.header} role={"banner"}>
                    <div className={styles.headerContainer}>
                        <HeaderInfo />
                    </div>
                </header>
            </div>
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "52px"
                }}
            >
                <embed id="pdf-embed" src={AIWorks_Guides} type="application/pdf" width={`${window.innerWidth}`} height={`${window.innerHeight - 63}`}></embed>
            </div>
        </div>
    );
};

export default GuideLines;
